import React from 'react'
import { Props_SnippetDualColumnContent } from './DualColumnContent.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const SnippetDualColumnContent = (props: Props_SnippetDualColumnContent) => {
    const { column1, column2 } = props

    return (
    <section className="snippet-dual-column-content">
        <div className="snippet-dual-column-content__container">
            <div className="snippet-dual-column-content__column">
                { column1.headingLevel?.value && React.createElement(column1.headingLevel?.value, { className: 'snippet-dual-column-content__heading' }, column1.heading?.value) }
                { column1.content?.value && (
                    <div className="snippet-dual-column-content__content">
                        { Legacy_CompileMarkdown(column1.content.value) }
                    </div>
                )}
            </div>
            { (column2.heading?.value || column2.content?.value) && (
            <div className="snippet-dual-column-content__column">
                { column2.headingLevel?.value && React.createElement(column2.headingLevel?.value, { className: 'snippet-dual-column-content__heading' }, column2.heading?.value) }
                { column2.content?.value && (
                    <div className="snippet-dual-column-content__content">
                        { Legacy_CompileMarkdown(column2.content.value) }
                    </div>
                )}
            </div>
            )}
        </div>
    </section>
    )
}

export default SnippetDualColumnContent
